module.exports = __webpack_public_path__ + "src/assets/img/qr-app-store.3872b1cf.svg";